import { createContext } from 'react';

export interface PopoverContextValue {
  checkActive: (id: string, groupId: string) => boolean;
  setActive: (id: string, groupId: string) => void;
  popovers: Record<string, string>;
}

export const PopoverManagerContext = createContext<PopoverContextValue>({
  checkActive: () => true,
  setActive: () => {},
  popovers: {}
});
